/* eslint-disable import/prefer-default-export */
import type { User } from '@/entities/Entities';

export function canAccess(user: User | undefined, roles?: string[]) {
  if (!roles) return true;
  if (!user) return false;
  return user.roles?.some((role) => roles.includes(role));
}
